import { EMP_TO_PAYMENT_METHOD, PAYMENT_METHODS } from "../constants";
import { PaymentMethod } from "../types/documents";

/**
 * Maps an EMP provider ID to a user-friendly payment method name
 * @param empProviderId The EMP provider ID from the accounting event
 * @returns A user-friendly payment method name
 */
export const mapEmpProviderToPaymentMethod = (
  empProviderId: string
): string => {
  return EMP_TO_PAYMENT_METHOD[empProviderId] ?? PAYMENT_METHODS.EMP;
};

/**
 * Gets the payment method name from a DBD PaymentMethod object
 * @param method The PaymentMethod object from DBD
 * @returns A user-friendly payment method name
 */
export const getDbdPaymentMethodName = (method: PaymentMethod): string => {
  const paymentMethod =
    method.paymentProvider.amazonManagedPayment?.name || "EMP";

  // Map DBD payment method names to our standardized payment method names if needed
  switch (paymentMethod) {
    case "CreditCard":
      return PAYMENT_METHODS.CREDIT_CARD;
    case "BankAccount":
      return PAYMENT_METHODS.DIRECT_DEBIT;
    default:
      return paymentMethod;
  }
};
